<app-common-grid [GridColumns]="gridColumns" [pageName]="'Front Running'" [exceptionCode]="'0002'"></app-common-grid>